import { Alert, AppBar, Avatar, Box, Button, Divider, IconButton, Menu, Modal, TextField, Toolbar, Tooltip, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useState, useEffect, useRef } from 'react';
import { AnalyticsOutlined, ArticleOutlined, BrowserUpdatedOutlined, CalculateOutlined, Close, CloudDownloadOutlined, ContactSupportOutlined, ContentCopy, DeliveryDiningOutlined, FormatPaintOutlined, GroupsOutlined, HistoryOutlined, HomeOutlined, InventoryOutlined, LoginOutlined, MenuRounded, MopedOutlined, PointOfSaleOutlined, PrintOutlined, QrCodeOutlined, BugReportOutlined, RestaurantOutlined, RoomServiceOutlined, SentimentDissatisfiedOutlined, SettingsOutlined, ShareOutlined, StoreOutlined, TableBarOutlined, VolumeOffOutlined, VolumeUpOutlined, AccountBalanceWalletOutlined } from '@mui/icons-material';
import { formatarHorarioCompleto, stringAvatar } from '../functions/utils';
import { useNavigate } from 'react-router-dom';

import useMediaQuery from '@mui/material/useMediaQuery';
import React from 'react';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import axios from 'axios';
import { CustomDrawer } from './CustomDrawer';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 500,
    bgcolor: 'background.paper',
    boxShadow: 24,
    borderRadius: "8px",
};

const SideMenu = ({ onChange, update, colorPrimary }) => {

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const navigate = useNavigate();

    const [anchorEl, setAnchorEl] = useState(null);
    const [statusLoja, setStatusLoja] = useState("aberto");
    const [impressora, setImpressora] = useState("");
    const [volume, setVolume] = useState("");
    const [descricao, setDescricao] = useState("");
    const [openModal, setOpenModal] = useState(false);
    const [openModalReport, setOpenModalReport] = useState(false);
    const [noAccess, setNoAccess] = useState(false);
    const [modalPdv, setModalPdv] = useState(false);
    const [isEstoqueMinimo, setIsEstoqueMinimo] = useState(false);
    const [currentPage, setCurrentPage] = useState("home");
    const [urlBase, setUrlBase] = useState("");
    const [tempoEntrega, setTempoEntrega] = useState("");
    const [alerts, setAlerts] = useState([]);
    const [dataAtual, setDataAtual] = useState(new Date());
    const [colorPrimaryS, setColorPrimary] = useState(false);
    const [planoGustio, setPlanoGustio] = useState("");
    const [betaAtivo, setBetaAtivo] = useState("");
    const [usuarioEmDia, setUsuarioEmDia] = useState("");
    const [sistemaInstavel, setSistemaInstavel] = useState(0);
    const [loadingPdv, setLoadingPdv] = useState(false);
    const [progress, setProgress] = useState(0);
    const [isRunning, setIsRunning] = useState(false);
    const [open, setOpen] = React.useState(false);
    const [isPdv, setIsPdv] = React.useState(false);
    const [retiradaNovos, setRetiradaNovos] = React.useState(0);
    const [mesasNovos, setMesasNovas] = React.useState(0);
    const [deliveryNovos, setDeliveryNovos] = React.useState(0);

    const intervalIdRef = useRef(null);
    const openPerfil = Boolean(anchorEl);

    const toggleDrawer = (newOpen) => () => {
        setOpen(newOpen);
    };

    const handleOpenModal = () => {
        setOpenModal(true);
        setModalPdv(false)
    };

    const handleCloseModal = () => {
        setNoAccess(false);
        setOpenModal(false);
    };

    const handleCloseModalReport = () => {
        setNoAccess(false);
        setOpenModalReport(false);
    };

    const handleShare = () => {
        handleOpenModal()
    }

    // const handleStatus = (event) => {
    //     setStatusLoja(event.target.value)
    // }

    const handleDescricao = (event) => {
        setDescricao(event.target.value)
    }

    const changePage = (page) => {
        console.log("Usuario em dia: ", usuarioEmDia);
        if(sistemaInstavel === 1) {
            handleAlert("Estamos com uma instabilidade temporária na conexão. Nosso time técnico já está trabalhando na resolução.", "warning")
            setSistemaInstavel(2)
        }
        else if (!usuarioEmDia && page !== "suporte" && page !== "logout" && page !== "erro" && page !== "home") {
            handleAlert("Sua loja está suspensa por falta de pagamento, entre em contato com nosso suporte para regularizar sua situação.", "error")
            return
        }
        if (page === "logout") {
            handleLogout();
        }
        let professionalPages = "entrega,mesa,retirada,historico,despesas,fechamento,clientes,dashboard"
        let pdvPages = "entrega,mesa,retirada,historico,dashboard"
        if ((planoGustio.toLowerCase() !== "profissional" && professionalPages.includes(page)) || ((pdvPages.includes(page) && !isPdv))) {
            setNoAccess(true);
            setOpenModal(true);
            setModalPdv(false);
            return
        }

        if (page === "pdv") {
            handleModalPdv()
            return
        }
        if (page === "erro") {
            handleModalReport()
            return
        }

        handleCloseModal()
        setOpen(false)
        onChange("", page);
        setCurrentPage(page);
    }

    const limparTimersPedidos = () => {
        if (window.verificaUltimoPedido) {
            clearInterval(window.verificaUltimoPedido);
            window.verificaUltimoPedido = null;
        }
        if (window.verificarPedidosImprimir) {
            clearInterval(window.verificarPedidosImprimir);
            window.verificarPedidosImprimir = null;
        }
    }

    const getPlanoUsuario = () => {
        if (!localStorage.getItem("emEst")) {
            handleLogout();
        }
        axios.post(`https://gerenciador.gustio.com.br/api/plano.php`, {
            email: localStorage.getItem("emEst"),
        })
            .then(response => {
                response = response.data
                if (response) {
                    setPlanoGustio(response[0].plano)
                    setBetaAtivo(response[0].habilita_beta === "S")
                    if (!response[0].status_pagamento) {
                        console.log("Usuario ainda não atualizado.");
                        setUsuarioEmDia(true);
                        return;
                    }
                    const timestamp = response[0].status_pagamento;
                    if (!isNaN(timestamp) && Number.isInteger(Number(timestamp)) && Number(timestamp) > 0) {
                        const dataTimestamp = new Date(Number(timestamp) * 1000);
                        const agora = new Date();
                        const timestampAgora = Date.now() / 1000;

                        const diasPassados = (agora - dataTimestamp) / (1000 * 60 * 60 * 24);

                        if (response[0].data_expiracao) {
                            const expiracao = Number(response[0].data_expiracao) + 604800;

                            if (timestampAgora >= expiracao) {
                                setUsuarioEmDia(false);
                            } else {
                                setUsuarioEmDia(true);
                            }
                        } else {
                            if (diasPassados > 37) {
                                console.log(`Atrasado mais de ${diasPassados} dias`);
                                setUsuarioEmDia(false);
                            } else {
                                setUsuarioEmDia(true);
                                console.log('Ainda não passaram 37 dias');
                            }
                        }
                    } else {
                        console.log("Atualização necessária.");
                        setUsuarioEmDia(false);
                    }
                }
            }).catch( err => {
                setPlanoGustio("Profissional")
                setUsuarioEmDia(true);
                setSistemaInstavel(1);
            })
    }

    useEffect(() => {
        const idBase = localStorage.getItem("Md")
        const urlBase = localStorage.getItem("UBs")
        const isLogged = localStorage.getItem("isLogged")
        if (!idBase || !urlBase || !isLogged || isLogged !== "true") {
            console.log("SESSÃO EXPIRADA")
            alert("Sua sessão expirou. Por favor, realize o login novamente.");
            navigate("/estabelecimento", { replace: true, state: { page: "home" } });
            return
        }
        getPlanoUsuario()

        const impressora = localStorage.getItem("IAt") !== "false";
        setImpressora(impressora)

        const audio = localStorage.getItem("Aud") !== "false";
        setVolume(audio)

        setIsPdv(localStorage.getItem("iSpA") === "true")
        const timer = setInterval(() => {
            updateNotifications();
            setDataAtual(new Date());
        }, 1000);

        return () => clearInterval(timer);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [navigate]);

    useEffect(() => {
        const urlbase = localStorage.getItem('UBs');
        setUrlBase(urlbase)
        const timeDelivery = localStorage.getItem('tD');
        const arrTime = timeDelivery.split("(")
        setTempoEntrega(arrTime[1].replaceAll(")", ""))
        getHorarios(urlbase)
        if (localStorage.getItem('eMA')) {
            setIsRunning(true);
        }
    }, [currentPage]);

    useEffect(() => {
        if (isRunning) {
            intervalIdRef.current = setInterval(() => {
                getProdutos();
            }, 10000);
        }

        return () => {
            if (intervalIdRef.current) {
                clearInterval(intervalIdRef.current);
            }
        };
    }, [isRunning]);

    const updateNotifications = () => {
        const mesasNovas = localStorage.getItem("msNv") ? localStorage.getItem("msNv") : 0;
        const deliveryNovos = localStorage.getItem("dlNv") ? localStorage.getItem("dlNv") : 0;
        const retiradaNovos = localStorage.getItem("rtNv") ? localStorage.getItem("rtNv") : 0;
        setMesasNovas(mesasNovas)
        setDeliveryNovos(deliveryNovos)
        setRetiradaNovos(retiradaNovos)
        onChange("", "updateNot")
    }

    const getHorarios = (url) => {
        axios.post(`${url}/horarios.php`, {
            idestabelecimentos: localStorage.getItem("Md"),
        })
            .then(response => {
                response = response.data

                if (localStorage.getItem("FxEst") === "1") {
                    setStatusLoja("fechado")
                    return
                }

                const horariosArray = response[0].horarios.split(",");
                const d = new Date();
                let diasemana
                if (d.getDay() === 0) {
                    diasemana = horariosArray[6]
                } else {
                    diasemana = horariosArray[d.getDay() - 1]
                }
                if (diasemana === "Fechado") {
                    setStatusLoja("fechado")
                } else {
                    let unix = Math.round(+new Date() / 1000);
                    const horarios = diasemana.split(" às ");
                    const horario1 = horarios[0].split(":");
                    let unix1 = Math.round(+new Date(d.getFullYear(), d.getMonth(), d.getDate(), horario1[0], horario1[1]) / 1000);
                    const horario2 = horarios[1].split(":");
                    let unix2 = Math.round(+new Date(d.getFullYear(), d.getMonth(), d.getDate(), horario2[0], horario2[1]) / 1000);

                    if (parseInt(horario2[0]) < parseInt(horario1[0]) || (horarios[0] === "00:00" && horarios[1] === "00:00")) {
                        unix2 += 86400
                    }

                    if (unix > unix1 && unix < unix2) {
                        setStatusLoja("aberto")
                    } else {
                        setStatusLoja("fechado")
                    }
                }

            })
            .catch(error => console.log("Não foi possivel conectar ao servidor, verifique sua conexão e tente novamente."));
    }

    useEffect(() => {
        if (update.includes("PDV")) {
            setOpenModal(true)
            setModalPdv(true)
        } else if (update.includes("estoque")) {
            const arrClr = update.split("___")
            if (arrClr[2] === "true") {
                setIsRunning(true)
            }
            getProdutos()
        } else if (update.includes("STPG")) {
            const arrClr = update.split("___")
            setCurrentPage(arrClr[1])
        } else if (update.includes("STLJ")) {
            const arrClr = update.split("___")
            setStatusLoja(arrClr[1])
        } else if (update.includes("UPDTCLP")) {
            const arrClr = update.split("___")
            setColorPrimary(arrClr[1])
        } else if (update.includes("UPDTNTF")) {
            return
        } else {
            const arrAlert = update.split("___")
            handleAlert(arrAlert[2], arrAlert[1])
        }
    }, [update]);

    const getProdutos = () => {
        const urlBase = localStorage.getItem('UBs');
        axios.post(`${urlBase}/produtos-inventario.php?idestabelecimentos=${localStorage.getItem("Md")}`, {
            idestabelecimentos: localStorage.getItem("Md")
        })
            .then(response => {
                response = response.data
                if (response) {
                    for (const produto of response) {
                        if (localStorage.getItem('eMA') === "true") {
                            const estoqueMinimo = parseInt(localStorage.getItem('eMAv'))
                            if (parseInt(produto.estoque) <= estoqueMinimo) {
                                setIsEstoqueMinimo(true)
                                return
                            }
                        } else {
                            setIsEstoqueMinimo(false)
                            setIsRunning(false)
                        }
                    }
                    setIsEstoqueMinimo(false)
                }
            })
    }

    const copyToClipboard = (text) => {
        if (navigator.clipboard) {
            navigator.clipboard.writeText(text)
                .then(() => {
                    setOpenModal(false);
                    handleAlert("Link copiado com sucesso.", "success")
                })
                .catch(err => {
                    handleAlert("Não foi possivel copiar o link", "error")
                });
        } else {
            const textArea = document.createElement('textarea');
            textArea.value = text;
            document.body.appendChild(textArea);
            textArea.select();
            try {
                document.execCommand('copy');
                handleAlert("Link copiado com sucesso.", "success")
            } catch (err) {
                handleAlert("Não foi possivel copiar o link", "error")
            }
            document.body.removeChild(textArea);
        }
    }

    const handleAlert = (mensagem, tipo) => {
        if (mensagem) {
            const id = new Date().getTime();
            const newAlert = { id, mensagem, tipo };
            setAlerts(prevAlerts => [...prevAlerts, newAlert]);

            setTimeout(() => {
                setAlerts(prevAlerts => prevAlerts.filter(alert => alert.id !== id));
            }, 5000);
        }
    };

    const handleCloseAlert = (id) => {
        setAlerts(prevAlerts => prevAlerts.filter(alert => alert.id !== id));
    };

    const getColorAlert = (tipoAlerta) => {
        switch (tipoAlerta) {
            case "success":
                return "#33550F";
            case "info":
                return "#464545";
            case "warning":
                return "#464545";
            case "error":
                return "#333";
            default:
                return "#464545";
        }
    }

    const getBackgroundAlert = (tipoAlerta) => {
        switch (tipoAlerta) {
            case "success":
                return "#F4F9EC";
            case "info":
                return "#ECF0F9";
            case "warning":
                return "#fffae6";
            case "error":
                return "#FFE9E6";
            default:
                return "#fffae6";
        }
    }

    const handleCopy = () => {
        copyToClipboard(urlBase.replaceAll("/api", ""));
    };

    const handleOpenPerfil = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClosePerfil = () => {
        setAnchorEl(null);
    };

    const handleSuporte = () => {
        handleClosePerfil()
        changePage("suporte")
    };

    const handleConfiguracoes = () => {
        handleClosePerfil()
        changePage("configuracoes")
    };

    const handleModalPdv = () => {
        setOpenModal(true)
        setModalPdv(true)
    };

    const handleModalReport = () => {
        setOpenModalReport(true)
    };

    const handleImpressora = () => {
        setImpressora(!impressora)
        localStorage.setItem('IAt', !impressora, { expires: 7 });
    };

    const handleVolume = () => {
        setVolume(!volume)
        localStorage.setItem('Aud', !volume, { expires: 7 });
    };

    const handleLogout = () => {
        localStorage.getItem("iSpA") === "true" ? localStorage.setItem('DSlP', true, { expires: 7 }) : console.log(":..")
        localStorage.removeItem('dsEst');
        localStorage.removeItem('emEst');
        localStorage.removeItem('endEst');
        localStorage.removeItem('fMsP');
        localStorage.removeItem('hREst');
        localStorage.removeItem('iEst');
        localStorage.removeItem('nmEst');
        localStorage.removeItem('txEst');
        localStorage.removeItem('tEst');
        localStorage.removeItem('tsEst');
        localStorage.removeItem('pmUs');
        localStorage.removeItem('UBs');
        localStorage.removeItem('FTs');
        localStorage.removeItem('isLogged');
        localStorage.removeItem('isStore');
        limparTimersPedidos();
        navigate("/estabelecimento/login", { replace: true, state: { page: "home" } });
    };

    const handleBaixarPDV = () => {
        setLoadingPdv(true);
        axios.post('https://gustio.com.br/download-pdv.php', {
            idestabelecimentos: localStorage.getItem("Md")
        }, {
            responseType: 'blob',
            onDownloadProgress: (progressEvent) => {
                const total = progressEvent.total;
                const current = progressEvent.loaded;
                const percentCompleted = Math.round((current / total) * 100);
                setProgress(percentCompleted);
            }
        })
            .then(response => {
                const blob = new Blob([response.data], { type: 'application/zip' });
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.style.display = 'none';
                a.href = url;
                a.download = `pdv-gustio.zip`;
                document.body.appendChild(a);
                a.click();
                window.URL.revokeObjectURL(url);
                setLoadingPdv(false);
            })
            .catch(error => {
                setLoadingPdv(false);
            });
    }

    const handleReport = () => {

        if (!descricao) {
            handleAlert("Por favor preencha a descrição do problema.", "error")
            return
        }

        const post_url = "https://gerenciador.gustio.com.br/api/report-email.php";
        const json = JSON.stringify({
            nome: localStorage.getItem('nmEst'),
            email: localStorage.getItem('emEst'),
            telefone: localStorage.getItem('tEst'),
            url: localStorage.getItem('UBs'),
            mensagem: descricao
        });

        axios.post(post_url, json)
            .then(resp => {
                const response = resp.data
                if (response) {
                    if (response.resposta === "success") {
                        handleAlert("Sua solicitação de suporte foi enviada com sucesso.", "success")
                        setDescricao("")
                        handleCloseModalReport()
                        return
                    }
                }
                handleAlert("Não foi possivel enviar a sua solicitação de suporte. Por favor verifique sua conexão e tente novamente.", "error")
            })
            .catch(error => {
                handleAlert("Não foi possivel conectar ao servidor, verifique sua conexão e tente novamente.", "error")
            });

    };

    const handleStatus = () => {
        const status = statusLoja === "aberto" ? 1 : 0;
        const statusName = statusLoja === "aberto" ? "fechado" : "aberto";
        const post_url = `https://gerenciador.gustio.com.br/api/fechar-estabelecimento.php`;
        axios.post(post_url, {
            fechar: status,
            id: localStorage.getItem("iCtMl")
        })
            .then(resp => {
                const response = resp.data
                if (response && response.resposta === "Registro atualizado com sucesso") {
                    handleAlert("Status da loja alterado com sucesso!")
                    setStatusLoja(statusName);
                }
            })
            .catch(error => {
            });
    }


    return (
        <>
            <AppBar position="fixed" style={{ backgroundColor: `rgba(${colorPrimaryS})`, color: "#FFF", fontWeight: "bold", boxShadow: "none", fontFamily: "roboto", height: 75, display: "flex", justifyContent: "center" }}>
                <Toolbar>

                    {isMobile ?
                        <>
                            <IconButton size="large" color="inherit" style={{ color: "#FFF" }} onClick={() => setOpen(true)}>
                                <MenuRounded style={{ fontSize: 42 }} />
                            </IconButton>
                            <IconButton size="large" color="inherit" style={{ color: "#FFF", marginLeft: "auto" }} onClick={handleShare}>
                                <ShareOutlined />
                            </IconButton>
                            {usuarioEmDia ?
                                <Button style={{ color: "white", textTransform: 'none', marginLeft: 6 }} startIcon={<StoreOutlined />}>
                                    Loja&nbsp;&nbsp;<div style={{ borderRadius: "50%", background: statusLoja === "aberto" ? "#6B9F29" : "tomato", height: 14, width: 14, marginTop: -3 }} />
                                </Button>
                                :
                                <Button style={{ color: "white", textTransform: 'none', marginLeft: 6 }} startIcon={<StoreOutlined />}>
                                    Loja&nbsp;&nbsp;<div style={{ borderRadius: "50%", background: "tomato", height: 14, width: 14, marginTop: -3 }} />
                                </Button>
                            }
                            <Button style={{ color: "white", textTransform: 'none', marginLeft: 6 }} startIcon={<MopedOutlined />}>
                                {tempoEntrega}
                            </Button>
                        </>
                        :
                        <>
                            {/* <TextField
                                color='secondary'
                                placeholder="Buscar"
                                sx={{ m: 1, width: '25ch', marginLeft: "315px" }}
                                InputProps={{
                                    endAdornment: <InputAdornment position="start"><Search /></InputAdornment>,
                                }}
                            /> */}


                            {/* <IconButton size="large" color="inherit" style={{ color: "#FFF" }} onClick={handleShare}>
                                <ShareOutlined />
                            </IconButton> */}
                            <Typography style={{ marginLeft: "auto" }}>{formatarHorarioCompleto(dataAtual)}</Typography>
                            &nbsp;&nbsp;&nbsp;
                            <div style={{ background: "#fff", width: 1, height: "60%", marginLeft: 10 }} />
                            &nbsp;&nbsp;&nbsp;
                            <Tooltip title={`Tempo de entrega: ${tempoEntrega}`}>
                                <Button style={{ color: "white", textTransform: 'none' }} startIcon={<MopedOutlined />}>
                                    {tempoEntrega}
                                </Button>
                            </Tooltip>

                            <Tooltip title={usuarioEmDia ? `Loja ${statusLoja === "aberto" ? "aberta" : "fechada"}` : "Loja suspensa por falta de pagamento"}>
                                {usuarioEmDia ?
                                    <Button onClick={handleStatus} style={{ color: "white", textTransform: 'none', marginLeft: 16 }} startIcon={<StoreOutlined />}>
                                        Loja&nbsp;&nbsp;<div style={{ borderRadius: "50%", background: statusLoja === "aberto" ? "#6B9F29" : "tomato", height: 14, width: 14, marginTop: -3 }} />
                                    </Button>
                                    :
                                    <Button style={{ color: "white", textTransform: 'none', marginLeft: 16 }} startIcon={<StoreOutlined />}>
                                        Loja&nbsp;&nbsp;<div style={{ borderRadius: "50%", background: "tomato", height: 14, width: 14, marginTop: -3 }} />
                                    </Button>
                                }
                            </Tooltip>

                            {isPdv &&
                                <Tooltip title={`Impressora ${impressora ? "ativa" : "inativa"}`}>
                                    <Button onClick={handleImpressora} style={{ color: "white", textTransform: 'none', marginLeft: 16 }} startIcon={<PrintOutlined />}>
                                        Impressora&nbsp;&nbsp;<div style={{ borderRadius: "50%", background: impressora === "" ? "#f2f2f2" : impressora ? "#6B9F29" : "tomato", height: 14, width: 14, marginTop: -3 }} />
                                    </Button>
                                </Tooltip>
                            }

                            <div style={{ background: "#fff", width: 1, height: "60%", marginLeft: 10 }} />

                            <Tooltip title={`Compartilhar`}>
                                <IconButton size="large" color="inherit" style={{ color: "#FFF", marginLeft: 4 }} onClick={handleShare}>
                                    <ShareOutlined />
                                </IconButton>
                            </Tooltip>

                            {isPdv &&
                                <Tooltip title={`Som ${volume ? "ativo" : "inativo"}`}>
                                    <IconButton onClick={handleVolume} size="large" color="inherit" style={{ color: "#FFF" }}>
                                        {volume ?
                                            <VolumeUpOutlined />
                                            :
                                            <VolumeOffOutlined />
                                        }
                                    </IconButton>
                                </Tooltip>
                            }

                            <Tooltip title={`Perfil`}>
                                <Avatar {...stringAvatar(localStorage.getItem("Mn"))} style={{ width: "38px", height: "38px", fontSize: 14, fontWeight: "400", marginLeft: 16, cursor: "pointer" }} onClick={handleOpenPerfil} />
                            </Tooltip>
                            <Menu id="perfil" anchorEl={anchorEl} open={openPerfil} onClose={handleClosePerfil}
                                MenuListProps={{
                                    'aria-labelledby': 'basic-button',
                                }}
                            >
                                <div style={{ display: "flex", alignItems: "center" }}>
                                    <Avatar {...stringAvatar(localStorage.getItem("Mn"))} style={{ width: "38px", height: "38px", fontSize: 14, fontWeight: "400", marginLeft: 16, cursor: "pointer" }} />
                                    <div style={{ width: 10 }} />
                                    <Typography style={{ fontSize: 14, color: "#999" }}>
                                        <label style={{ fontSize: 16, color: "#1B1B1B" }}>{localStorage.getItem("Mn")}</label><br />
                                        {localStorage.getItem("emEst")}
                                    </Typography>
                                </div>

                                <div style={{ height: 10 }} />
                                <Divider />
                                <List style={{ width: 315, fontSize: 16 }}>
                                    <ListItem button onClick={handleSuporte}>
                                        <ContactSupportOutlined style={{ marginRight: 14, color: "#464545" }} />
                                        <ListItemText primary="Suporte" primaryTypographyProps={{ color: "#464545", fontWeight: "bold" }} />
                                    </ListItem>
                                    <ListItem button onClick={handleConfiguracoes}>
                                        <SettingsOutlined style={{ marginRight: 14, color: "#464545" }} />
                                        <ListItemText primary="Configurações" primaryTypographyProps={{ color: "#464545", fontWeight: "bold" }} />
                                    </ListItem>
                                    <ListItem button onClick={handleLogout}>
                                        <LoginOutlined style={{ marginRight: 14, color: "#464545" }} />
                                        <ListItemText primary="Sair" primaryTypographyProps={{ color: "#464545", fontWeight: "bold" }} />
                                    </ListItem>
                                </List>
                            </Menu>
                            {/* <Typography style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                Loja:
                                <div style={{ width: 10 }}></div>
                                <FormControl style={{ width: 150 }}>
                                    <Select
                                        value={statusLoja}
                                        placeholder="Status"
                                        onChange={handleStatus}
                                        color="secondary"
                                        style={{ color: statusLoja === "aberto" ? "green" : "tomato" }}
                                    >
                                        <MenuItem value={"aberto"} style={{ color: "green" }}>Aberto</MenuItem>
                                        <MenuItem value={"fechado"} style={{ color: "tomato" }}>Fechado</MenuItem>
                                    </Select>
                                </FormControl>
                                <div style={{ width: 10 }}></div>
                                <Avatar {...stringAvatar("Joelson Lucas")} style={{ margin: "auto", width: "38px", height: "38px", fontSize: 14 }} />

                            </Typography> */}
                        </>
                    }
                </Toolbar>
            </AppBar>

            {alerts.map(alert => (
                <Alert
                    key={alert.id}
                    variant="outlined"
                    severity={alert.tipo}
                    onClose={() => handleCloseAlert(alert.id)}
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'left',
                        color: getColorAlert(alert.tipo), fontSize: 14,
                        background: getBackgroundAlert(alert.tipo),
                        position: "fixed",
                        top: 100 + (alerts.indexOf(alert) * 60), // Ajusta a posição dos alertas
                        right: 24,
                        zIndex: 10000
                    }}
                >
                    <div>
                        <b style={{ fontSize: 16 }}>{alert.mensagem}</b>
                    </div>
                </Alert>
            ))}

            <Modal
                open={openModal}
                onClose={handleCloseModal}
            >
                <Box sx={style} style={{ width: isMobile ? "100%" : "" }}>
                    {noAccess && !isPdv && !modalPdv ?
                        <>
                            {planoGustio.toLowerCase() !== "profissional" && !isPdv ?
                                <>
                                    <Typography style={{ fontSize: 18, color: "#464545", fontWeight: "bold", display: "flex", padding: 16 }}>
                                        <SentimentDissatisfiedOutlined /> <div style={{ width: 10 }} /> Funcionalidade indisponível <Close style={{ marginLeft: "auto", cursor: "pointer" }} onClick={handleCloseModal} />
                                    </Typography>

                                    <Typography style={{ fontSize: 16, padding: 16, fontWeight: "normal", maxHeight: "70vh", overflowY: "auto" }}>
                                        Infelizmente essa funcionalidade só está disponível no plano <b>"Profissional"</b>, mas você pode fazer um upgrade no seu
                                        plano, clique no botão abaixo para entrar em contato com nosso suporte e faça seu upgrade.
                                    </Typography>

                                    <Typography style={{ padding: 16 }}>
                                        <Button variant="contained" fullWidth style={{ textTransform: 'none' }} onClick={() => changePage("suporte")} startIcon={<ContactSupportOutlined />}>
                                            Falar com suporte
                                        </Button>
                                    </Typography>
                                </>
                                :
                                <>
                                    <Typography style={{ fontSize: 18, color: "#464545", fontWeight: "bold", display: "flex", padding: 16 }}>
                                        <BrowserUpdatedOutlined /> <div style={{ width: 10 }} /> Que tal baixar nosso PDV? <Close style={{ marginLeft: "auto", cursor: "pointer" }} onClick={handleCloseModal} />
                                    </Typography>

                                    <Typography style={{ fontSize: 16, padding: 16, fontWeight: "normal", maxHeight: "70vh", overflowY: "auto" }}>
                                        Essa funcionalidade está disponível no nosso <b>PDV</b>, você pode baixar clicando no botão abaixo.
                                    </Typography>

                                    <Typography style={{ padding: 16 }}>
                                        <Button variant="contained" fullWidth style={{ textTransform: 'none' }} onClick={() => handleModalPdv()} startIcon={<CloudDownloadOutlined />}>
                                            Baixar PDV
                                        </Button>
                                    </Typography>
                                </>
                            }

                        </>
                        :
                        <>
                            <Typography style={{ fontSize: 18, color: "#464545", fontWeight: "bold", display: "flex", padding: 16 }}>
                                {modalPdv ?
                                    <>
                                        <CloudDownloadOutlined /> <div style={{ width: 10 }} /> Baixar PDV <Close style={{ marginLeft: "auto", cursor: "pointer" }} onClick={handleCloseModal} />
                                    </>
                                    :
                                    <>
                                        <ShareOutlined /> <div style={{ width: 10 }} /> Compartilhar <Close style={{ marginLeft: "auto", cursor: "pointer" }} onClick={handleCloseModal} />
                                    </>
                                }
                            </Typography>

                            <Divider />

                            {modalPdv ?
                                <Typography style={{ fontSize: 16, padding: 16, fontWeight: "normal", maxHeight: "70vh", overflowY: "auto" }}>
                                    <b>Ao baixar e utilizar nosso sistema de PDV, você reconhece e aceita os seguintes termos e condições:</b><br /><br />

                                    <b>Uso do Sistema: </b>Nosso sistema de PDV é fornecido "como está" e deve ser utilizado apenas para fins comerciais legítimos.<br />

                                    <b>Responsabilidade: </b>Não nos responsabilizamos por quaisquer danos ou perdas decorrentes do uso deste sistema de PDV.<br />

                                    <b>Atualizações: </b>Podemos realizar atualizações e modificações no sistema de PDV a qualquer momento, visando melhorias e correções.<br />

                                    <b>Privacidade: </b>Qualquer informação coletada através do uso do sistema será tratada conforme nossa política de privacidade.<br />

                                    <b>Suporte: </b>Oferecemos suporte técnico conforme descrito em nosso site e materiais de apoio.<br /><br />

                                    Agradecemos por escolher nosso sistema de PDV. <br />
                                </Typography>
                                :
                                <Typography style={{ fontSize: 16, padding: 16, fontWeight: "bold" }}>
                                    Copie o link abaixo para enviar<br />
                                    <Tooltip title={`Clique aqui para copiar o link`}>
                                        <Typography style={{ width: "100%", border: "solid 1px #DCDBDB", padding: 10, borderRadius: "4px", cursor: "pointer" }} onClick={handleCopy}>{urlBase.replaceAll("/api", "")}<ContentCopy style={{ float: "right" }} /></Typography>
                                    </Tooltip>
                                </Typography>
                            }

                            {modalPdv &&
                                <div style={{ paddingLeft: 16, paddingRight: 16 }}>
                                    <Divider />
                                    <br />
                                    <Button fullWidth size="large" variant="contained" style={{ textTransform: 'none' }} disabled={loadingPdv} onClick={handleBaixarPDV} startIcon={<CloudDownloadOutlined />}>
                                        {loadingPdv ? `Baixando... ${progress}%` : 'Baixar PDV'}
                                    </Button>
                                    <br />
                                    <br />
                                </div>
                            }
                        </>
                    }
                </Box>
            </Modal>

            <Modal open={openModalReport} onClose={handleCloseModalReport}>
                <Box sx={style} style={{ width: isMobile ? "100%" : "" }}>

                    <Typography style={{ fontSize: 18, color: "#464545", fontWeight: "bold", display: "flex", padding: 16 }}>
                        <BugReportOutlined /> <div style={{ width: 10 }} /> Quer reportar um erro no sistema? <Close style={{ marginLeft: "auto", cursor: "pointer" }} onClick={handleCloseModalReport} />
                    </Typography>

                    <Typography style={{ fontSize: 16, padding: 16, fontWeight: "normal", maxHeight: "70vh", overflowY: "auto" }}>
                        Conte-nos oque está acontecendo e vamos tentar auxilia-lo da melhor forma possivel.
                    </Typography>

                    <Box style={{ padding: 16 }}>
                        <Typography style={{ textAlign: "left", fontSize: "14px", fontWeight: "600" }}>
                            Descrição do problema <b style={{ color: "#A51D1D" }}>*</b>
                        </Typography>
                        <div style={{ height: 4 }}></div>
                        <TextField
                            fullWidth
                            hiddenLabel
                            value={descricao}
                            onChange={handleDescricao}
                            variant="outlined"
                            size="large"
                            inputProps={{ maxLength: 140 }}
                            placeholder="Digite aqui a descrição do problema"
                            type="text"
                            multiline
                            rows={4}
                        />

                        <Button variant="contained" fullWidth size="large" style={{ textTransform: 'none', marginTop: 16, fontWeight: "500" }} onClick={handleReport}>
                            Enviar
                        </Button>

                    </Box>

                </Box>
            </Modal>

            {isMobile && <Drawer open={open} onClose={toggleDrawer(false)}>
                <div style={{ display: "flex", alignItems: "center", color: "#999", fontSize: 12, fontWeight: "bold" }}>
                    <img alt="Logo GUSTIO" src="https://gustio.com.br/imagens/gustio-logo-white.png" style={{ width: 100, marginLeft: 20 }} />
                    {planoGustio === "PROFISSIONAL" &&
                        <Box sx={{ background: "#dd4c1b", color: "#fff", p: "3px", borderRadius: 1, px: 1, ml: 1 }}>Profissional</Box>
                    }
                    {planoGustio === "PADRÃO" &&
                        <Box sx={{ background: "#ffa50c", color: "#fff", p: "3px", borderRadius: 1, px: 1, ml: 1 }}>Padrão</Box>
                    }
                    {planoGustio === "BÁSICO" &&
                        <Box sx={{ background: "#b48f7d", color: "#fff", p: "3px", borderRadius: 1, px: 1, ml: 1 }}>Básico</Box>
                    }
                    &nbsp;&nbsp;&nbsp;v1.0.0.0
                </div>
                <List style={{ width: 315, padding: 20, paddingBottom: 0 }}>
                    <ListItem button style={{ background: currentPage === "home" ? "#F2F2F2" : "", borderRadius: 6 }} onClick={() => changePage("home")}>
                        <HomeOutlined style={{ marginRight: 14, color: "#464545" }} />
                        <ListItemText primary="Home" primaryTypographyProps={{ color: currentPage === "home" ? "#F94A3D" : "#464545", fontWeight: "bold" }} />
                    </ListItem>
                </List>
                <>
                    <List style={{ width: 315, padding: "5px 20px 0px 20px" }}>
                        <div style={{ height: 5 }} />
                        <Divider />
                        <div style={{ height: 5 }} />
                        <Typography style={{ fontSize: 14, fontWeight: 600, textAlign: "center", color: "#fff", background: "#F94A3D", borderRadius: 10, marginBottom: 5 }}>
                            Funções PDV
                        </Typography>
                        {/* <Accordion> */}
                        {/* <AccordionSummary aria-controls="panel1d-content" id="panel1d-header">
                                <MoveDownOutlined style={{ marginRight: 14, color: "#464545" }} />
                                <ListItemText primary="Gestão Pedidos" primaryTypographyProps={{ color: "#464545", fontWeight: "600" }} />
                                {(mesasNovos > 0 || deliveryNovos > 0 || retiradaNovos > 0) &&
                                    <Typography style={{ background: "#F94A3D", color: "white", padding: "0px 10px 0px 10px", borderRadius: 50, maxHeight: 20, marginTop: 6, marginRight: 10 }}></Typography>
                                }
                            </AccordionSummary> */}
                        {/* <AccordionDetails> */}
                        <ListItem button style={{ background: currentPage === "entrega" ? "#F2F2F2" : "", borderRadius: 6 }} onClick={() => changePage("entrega")}>
                            <DeliveryDiningOutlined style={{ marginRight: 14, color: "#464545" }} />
                            <ListItemText primary="Delivery" primaryTypographyProps={{ color: currentPage === "entrega" ? "#F94A3D" : "#464545", fontWeight: "600" }} />
                            {deliveryNovos > 0 &&
                                <Typography style={{ background: "#F94A3D", color: "white", padding: "0px 10px 0px 10px", borderRadius: 4, maxHeight: 24 }}>{deliveryNovos}</Typography>
                            }
                        </ListItem>
                        <ListItem button style={{ background: currentPage === "mesa" ? "#F2F2F2" : "", borderRadius: 6 }} onClick={() => changePage("mesa")}>
                            <TableBarOutlined style={{ marginRight: 14, color: "#464545" }} />
                            <ListItemText primary="Mesa" primaryTypographyProps={{ color: currentPage === "mesa" ? "#F94A3D" : "#464545", fontWeight: "600" }} />
                            {mesasNovos > 0 &&
                                <Typography style={{ background: "#F94A3D", color: "white", padding: "0px 10px 0px 10px", borderRadius: 4, maxHeight: 24 }}>{mesasNovos}</Typography>
                            }
                        </ListItem>
                        <ListItem button style={{ background: currentPage === "retirada" ? "#F2F2F2" : "", borderRadius: 6 }} onClick={() => changePage("retirada")}>
                            <RoomServiceOutlined style={{ marginRight: 14, color: "#464545" }} />
                            <ListItemText primary="Retirada" primaryTypographyProps={{ color: currentPage === "retirada" ? "#F94A3D" : "#464545", fontWeight: "600" }} />
                            {retiradaNovos > 0 &&
                                <Typography style={{ background: "#F94A3D", color: "white", padding: "0px 10px 0px 10px", borderRadius: 4, maxHeight: 24 }}>{retiradaNovos}</Typography>
                            }
                        </ListItem>
                        <ListItem button style={{ background: currentPage === "historico" ? "#F2F2F2" : "", borderRadius: 6 }} onClick={() => changePage("historico")}>
                            <HistoryOutlined style={{ marginRight: 14, color: "#464545" }} />
                            <ListItemText primary="Histórico" primaryTypographyProps={{ color: currentPage === "historico" ? "#F94A3D" : "#464545", fontWeight: "600" }} />
                        </ListItem>
                        {/* </AccordionDetails>
                        </Accordion> */}
                        <ListItem button style={{ background: currentPage === "dashboard" ? "#F2F2F2" : "", borderRadius: 6 }} onClick={() => changePage("dashboard")}>
                            <AnalyticsOutlined style={{ marginRight: 14, color: "#464545" }} />
                            <ListItemText primary="Dashboard" primaryTypographyProps={{ color: currentPage === "dashboard" ? "#F94A3D" : "#464545", fontWeight: "600" }} />
                        </ListItem>
                    </List>
                </>
                <div style={{ height: 10 }}></div>

                <List style={{ width: 315, padding: "5px 20px 0px 20px" }}>
                    <div style={{ height: 5 }} />
                    <Divider />
                    <div style={{ height: 5 }} />
                    <Typography style={{ fontSize: 14, fontWeight: 600, textAlign: "center", color: "#fff", background: "#F94A3D", borderRadius: 10, marginBottom: 5 }}>
                        Gestão Financeira
                    </Typography>
                    {/* <Accordion>
                        <AccordionSummary aria-controls="panel1d-content" id="panel1d-header">
                            <CurrencyExchangeOutlined style={{ marginRight: 14, color: "#464545" }} />
                            <ListItemText primary="Gestão Financeira" primaryTypographyProps={{ color: "#464545", fontWeight: "600" }} />
                        </AccordionSummary>
                        <AccordionDetails> */}
                    {betaAtivo &&
                        <ListItem button style={{ background: currentPage === "carteira" ? "#F2F2F2" : "", borderRadius: 6 }} onClick={() => changePage("carteira")}>
                            <AccountBalanceWalletOutlined style={{ marginRight: 14, color: "#464545" }} />
                            <ListItemText primary="Minha Carteira" primaryTypographyProps={{ color: currentPage === "carteira" ? "#F94A3D" : "#464545", fontWeight: "600" }} />
                        </ListItem>
                    }
                    <ListItem button style={{ background: currentPage === "despesas" ? "#F2F2F2" : "", borderRadius: 6 }} onClick={() => changePage("despesas")}>
                        <CalculateOutlined style={{ marginRight: 14, color: "#464545" }} />
                        <ListItemText primary="Fluxo de Caixa" primaryTypographyProps={{ color: currentPage === "despesas" ? "#F94A3D" : "#464545", fontWeight: "600" }} />
                    </ListItem>
                    <ListItem button style={{ background: currentPage === "fechamento" ? "#F2F2F2" : "", borderRadius: 6 }} onClick={() => changePage("fechamento")}>
                        <PointOfSaleOutlined style={{ marginRight: 14, color: "#464545" }} />
                        <ListItemText primary="Fechamento de Caixa" primaryTypographyProps={{ color: currentPage === "fechamento" ? "#F94A3D" : "#464545", fontWeight: "600" }} />
                    </ListItem>
                    {/* </AccordionDetails>
                    </Accordion> */}

                    <div style={{ height: 5 }} />
                    <Divider />
                    <div style={{ height: 5 }} />
                    <Typography style={{ fontSize: 14, fontWeight: 600, textAlign: "center", color: "#fff", background: "#F94A3D", borderRadius: 10, marginBottom: 5 }}>
                        Funções Gerais
                    </Typography>

                    <ListItem button style={{ background: currentPage === "clientes" ? "#F2F2F2" : "", borderRadius: 6 }} onClick={() => changePage("clientes")}>
                        <GroupsOutlined style={{ marginRight: 14, color: "#464545" }} />
                        <ListItemText primary="Clientes" primaryTypographyProps={{ color: currentPage === "clientes" ? "#F94A3D" : "#464545", fontWeight: "600" }} />
                    </ListItem>
                    <ListItem button style={{ background: currentPage === "pedidos" ? "#F2F2F2" : "", borderRadius: 6 }} onClick={() => changePage("pedidos")}>
                        <ArticleOutlined style={{ marginRight: 14, color: "#464545" }} />
                        <ListItemText primary="Pedidos" primaryTypographyProps={{ color: currentPage === "pedidos" ? "#F94A3D" : "#464545", fontWeight: "bold" }} />
                    </ListItem>
                    <ListItem button style={{ background: currentPage === "cardapio" ? "#F2F2F2" : "", borderRadius: 6 }} onClick={() => changePage("cardapio")}>
                        <RestaurantOutlined style={{ marginRight: 14, color: "#464545" }} />
                        <ListItemText primary="Cardápio" primaryTypographyProps={{ color: currentPage === "cardapio" ? "#F94A3D" : "#464545", fontWeight: "bold" }} />
                    </ListItem>
                    <ListItem button style={{ background: currentPage === "inventario" ? "#F2F2F2" : "", borderRadius: 6 }} onClick={() => changePage("inventario")}>
                        <InventoryOutlined style={{ marginRight: 14, color: "#464545" }} />
                        <ListItemText primary="Estoque" primaryTypographyProps={{ color: currentPage === "inventario" ? "#F94A3D" : "#464545", fontWeight: "bold" }} />
                        {isEstoqueMinimo &&
                            <>
                                <div style={{ borderRadius: "50%", background: "tomato", height: 14, width: 14, marginTop: -3 }} />
                            </>
                        }
                    </ListItem>
                    <ListItem button style={{ background: currentPage === "qrcode" ? "#F2F2F2" : "", borderRadius: 6 }} onClick={() => changePage("qrcode")}>
                        <QrCodeOutlined style={{ marginRight: 14, color: "#464545" }} />
                        <ListItemText primary="QR Code" primaryTypographyProps={{ color: currentPage === "qrcode" ? "#F94A3D" : "#464545", fontWeight: "bold" }} />
                    </ListItem>
                    <ListItem button style={{ background: currentPage === "personalizar" ? "#F2F2F2" : "", borderRadius: 6 }} onClick={() => changePage("personalizar")}>
                        <FormatPaintOutlined style={{ marginRight: 14, color: "#464545" }} />
                        <ListItemText primary="Personalizar" primaryTypographyProps={{ color: currentPage === "personalizar" ? "#F94A3D" : "#464545", fontWeight: "bold" }} />
                    </ListItem>
                    <ListItem button style={{ background: currentPage === "pdv" ? "#F2F2F2" : "", borderRadius: 6 }} onClick={() => handleModalPdv()}>
                        <BrowserUpdatedOutlined style={{ marginRight: 14, color: "#464545" }} />
                        <ListItemText primary="Baixar PDV" primaryTypographyProps={{ color: currentPage === "pdv" ? "#F94A3D" : "#464545", fontWeight: "600" }} />
                    </ListItem>
                </List>

                <div style={{ height: 20 }}></div>

                <List style={{ width: 315, padding: "5px 20px 0px 20px" }}>

                    <div style={{ height: 5 }} />
                    <Divider />
                    <div style={{ height: 5 }} />
                    <Typography style={{ fontSize: 14, fontWeight: 600, textAlign: "center", color: "#fff", background: "#F94A3D", borderRadius: 10, marginBottom: 5 }}>
                        Funções Suporte
                    </Typography>

                    <ListItem button style={{ background: currentPage === "configuracoes" ? "#F2F2F2" : "", borderRadius: 6 }} onClick={() => changePage("configuracoes")}>
                        <SettingsOutlined style={{ marginRight: 14, color: "#464545" }} />
                        <ListItemText primary="Configurações" primaryTypographyProps={{ color: currentPage === "configuracoes" ? "#F94A3D" : "#464545", fontWeight: "bold" }} />
                    </ListItem>
                    <ListItem button style={{ background: currentPage === "suporte" ? "#F2F2F2" : "", borderRadius: 6 }} onClick={() => changePage("suporte")}>
                        <ContactSupportOutlined style={{ marginRight: 14, color: "#464545" }} />
                        <ListItemText primary="Suporte" primaryTypographyProps={{ color: currentPage === "suporte" ? "#F94A3D" : "#464545", fontWeight: "bold" }} />
                    </ListItem>
                    <ListItem button onClick={handleModalReport}>
                        <BugReportOutlined style={{ marginRight: 14, color: "#464545" }} />
                        <ListItemText primary="Reportar Erro" primaryTypographyProps={{ color: "#464545", fontWeight: "bold" }} />
                    </ListItem>
                    <ListItem button onClick={handleLogout}>
                        <LoginOutlined style={{ marginRight: 14, color: "#464545" }} />
                        <ListItemText primary="Sair" primaryTypographyProps={{ color: "#464545", fontWeight: "bold" }} />
                    </ListItem>
                </List>
            </Drawer>
            }

            {!isMobile &&
                <CustomDrawer
                    open={open}
                    colorPrimary={colorPrimaryS}
                    toggleDrawer={toggleDrawer}
                    currentPage={currentPage}
                    changePage={changePage}
                    mesasNovos={mesasNovos}
                    deliveryNovos={deliveryNovos}
                    retiradaNovos={retiradaNovos}
                    plano={planoGustio}
                    betaAtivo={betaAtivo}
                />
            }

        </>
    );
};

export default SideMenu;
